/* CSS */
import "../css/landing.css";
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

/* JS */
import 'lazysizes';
import Accordions from './components/accordion';
import initShopTheLook from './components/shopthelook.js';
import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

import { initCookieConsent } from './cookie-consent';

// Swiper Alpine Component
const swiper = (e={})=>({
    options: {
        grabCursor: true,
        pagination: {
            el: ".swiper-pagination",
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        modules: [Navigation, Pagination],
        ...e
    },
    swiper: null,
    init() {
        if (this.swiper !== null)
            return;
        let t = this.$refs.swiper ?? this.$el;
        this.swiper = new Swiper(t,this.options),
        this.$refs.progress && this.swiper.slides.length > 1 && this.swiper.on("autoplayTimeLeft", ()=>{
            let i = this.swiper.autoplay.timeLeft;
            i < 0 || i === 7e3 ? this.$refs.progress.style.width = "100%" : this.$refs.progress.style.width = 100 - i / 7e3 * 100 + "%"
        })

    },
    prev() {
        this.swiper && this.swiper.slidePrev()
    },
    next() {
        this.swiper && this.swiper.slideNext()
    }
});



window.youtubeEmbeds = function () {
	console.log('Youtube Embeds fired')
	var youtubeEmbeds = document.querySelectorAll('[data-youtube-embed]')
	for (var i = 0; i < youtubeEmbeds.length; i++) {
		youtubeEmbeds[i].addEventListener('click', function () {
			var iframe = document.createElement('iframe')

			iframe.setAttribute('frameborder', '0')
			iframe.setAttribute('allowfullscreen', '')
			iframe.setAttribute(
				'allow',
				'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
			)
			iframe.setAttribute(
				'src',
				'https://www.youtube.com/embed/' +
					this.dataset.youtubeEmbed +
					'?rel=0&showinfo=0&autoplay=1'
			)

			this.innerHTML = ''
			this.appendChild(iframe)
		})
	}
}

/**
 * Track elements in GA4
 */
window.trackElements = function () {
  let elementsToTrack = document.querySelectorAll('[data-track]')

  elementsToTrack.forEach((element) => {
    if (element) {
      element.addEventListener('click', function (e) {
        e.preventDefault()
        trackEvent('elementClicked', {
          element: element.dataset.track,
        })
      })
    }
  })

}

initShopTheLook();

document.addEventListener('DOMContentLoaded', function () {
    youtubeEmbeds();
    Accordions();

    // Get language from html lang attribute
    const lang = document.documentElement.lang?.substring(0, 2) || 'nl';
    initCookieConsent(lang);
  // trackElements();
})


window.Alpine = Alpine;

Alpine.data('swiper', swiper);
Alpine.plugin(collapse);
Alpine.start();
